<mat-card style=" box-shadow:none; width: 100%;" [class.mat-elevation-z1]="'true'">
    <mat-card-header style="      margin-top: -43px !important;
    margin-left: -43px !important;
    margin-right: 0px !important;">

        <span mat-card-avatar>
            <mat-icon>history</mat-icon>
        </span>
        <mat-card-title>History : {{amcoId}}</mat-card-title>
        <br>
        <button class="button-close" mat-raised-button (click)="onCancelClick()"><mat-icon>close</mat-icon></button>
    </mat-card-header>
    <mat-dialog-content style=" margin-left: -43px !important;">
        <mat-tab-group class="table-container">
            <mat-tab label="Shipment History">
                <br>
               <!-- <div *ngFor="let audit of audits; let i = index">
                    <mat-grid-list cols="4" rowHeight="100px">
                        <mat-grid-tile><br><span style="display: block; color: rgb(158, 158, 153);width: 100;    font-weight: 500;"><b style="font-weight: 500 !important;">Update Type</b></span><br><span><b style="  color: #15457f;">{{audit.updateType}}</b></span></mat-grid-tile>
                        <mat-grid-tile><br><span style="display: block; color: rgb(158, 158, 153);width: 100;    font-weight: 500;"><b style="font-weight: 500 !important;">Date / Time</b></span><br><span><b style="  color: #15457f;">{{audit.date | date :'dd-MMM-yyyy HH:mm'}}</b></span></mat-grid-tile>
                        <mat-grid-tile><br><span style="display: block; color: rgb(158, 158, 153);width: 100;    font-weight: 500;"><b style="font-weight: 500 !important;">Updated At</b></span><br><span><b style="  color: #15457f;">{{audit.updatedAt | date :'dd-MMM-yyyy HH:mm'}}</b></span></mat-grid-tile>
                        <mat-grid-tile><br><span style="display: block; color: rgb(158, 158, 153);width: 100;    font-weight: 500;"><b style="font-weight: 500 !important;">User</b></span><br><span><b style="  color: #15457f;">{{audit.user}}</b></span></mat-grid-tile>
                        <mat-grid-tile  [colspan]="4" [rowspan]="1" style="background: #f2f2f2; margin-left: -6px;
                        margin-top: 10px !important;"><span style="color: rgb(158, 158, 153);width: 100; padding: 10px; margin-top: 10px;    font-weight: 500;"><b style="font-weight: 500 !important;">Note : </b></span><span><b style="    color: #8f8f8f;
                        font-weight: 400; margin-top:10px;">{{audit.note}}</b></span></mat-grid-tile>
                    </mat-grid-list>
                </div><br> -->
                <div>
                <table mat-table [dataSource]="adminApproved" class="mat-elevation-z8" style="width: 100% !important; height: 60% !important;">
                    <!-- Icon Column -->
                    <ng-container matColumnDef="icon">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let audit; let i = index" >
                        <ng-container *ngIf="isFirstInGroup(audit, i) && groupCounts[audit.groupId] > 1">
                          <button mat-icon-button (click)="toggleGroup(audit.groupId)">
                            <mat-icon>{{ groupCollapsed[audit.groupId] ? 'chevron_right' : 'expand_more' }}</mat-icon>
                          </button>
                        </ng-container>
                      </td>
                    </ng-container>

                    <!-- Update Type Column -->
                    <ng-container matColumnDef="updateType">
                      <th mat-header-cell *matHeaderCellDef>Update Type</th>
                      <td mat-cell *matCellDef="let audit; let i = index" [hidden]="groupCollapsed[audit.groupId] && !isFirstInGroup(audit, i)">
                        <ng-container *ngIf="isFirstInGroup(audit, i)">
                            {{ getVehicleUpdateType(audit.updateType, audit.note) ? 'Vehicle Assigned' :  audit.updateType }}
                        </ng-container>
                      </td>
                    </ng-container>

                    <!-- Date/Time Column -->
                    <ng-container matColumnDef="date">
                      <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Date / Time</th>
                      <td mat-cell *matCellDef="let audit; let i = index" [hidden]="groupCollapsed[audit.groupId] && !isFirstInGroup(audit, i)">
                        {{ audit.date | date: 'dd-MMM-yyyy HH:mm' }}
                      </td>
                    </ng-container>

                    <!-- Updated At Column -->
                    <div *ngIf="!isCustomer">
                        <ng-container matColumnDef="updatedAt" >
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Updated At</th>
                        <td mat-cell *matCellDef="let audit; let i = index" [hidden]="groupCollapsed[audit.groupId] && !isFirstInGroup(audit, i)">
                            {{ audit.updatedAt | date: 'dd-MMM-yyyy HH:mm' }}
                        </td>
                        </ng-container>
                    </div>

                    <!-- User Column -->
                    <div *ngIf="!isCustomer">
                        <ng-container matColumnDef="user" >
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">User</th>
                        <td mat-cell *matCellDef="let audit; let i = index" [hidden]="groupCollapsed[audit.groupId] && !isFirstInGroup(audit, i)">
                            {{ getAuditHistoryUserDisplay(audit.user) }}
                        </td>
                        </ng-container>
                    </div>

                    <!-- Note Column -->
                    <ng-container matColumnDef="note">
                        <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Note</th>
                        <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis !important;">
                            <div
                                style="white-space: pre-wrap; word-break: break-word;">
                                {{ audit.note }}
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let audit; let i = index; columns: displayedColumns;" [hidden]="groupCollapsed[audit.groupId] && !isFirstInGroup(audit, i)"></tr>
                  </table>
                </div>
            </mat-tab>
            <mat-tab label="Vehicle History" *ngIf="false">
                <div>
                <table class="tgrey" mat-table matSort [dataSource]="dataSource" style="width: 100%;">

                    <ng-container matColumnDef="positionDateTime">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 12px !important; font-weight: 700; text-align: center;    padding-left: 1px;">
                            Position DateTime</th>
                        <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                            {{ element.positionDateTime | date: 'medium' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 12px !important; font-weight: 700; text-align: center;    padding-left: 1px;">
                            Address</th>
                        <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                            {{ element.addressInfo}}</td>
                    </ng-container>

                    <ng-container matColumnDef="countryCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 12px !important; font-weight: 700; text-align: center;    padding-left: 1px;">
                            Country Code</th>
                        <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                            {{element.countryCode}}</td>
                    </ng-container>

                    <ng-container matColumnDef="zipCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 12px !important; font-weight: 700; text-align: center;    padding-left: 1px;">
                            Zip Code</th>
                        <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                            {{element.zipCode}}</td>
                    </ng-container>

                    <ng-container matColumnDef="nearestCity">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 12px !important; font-weight: 700; text-align: center;    padding-left: 1px;">
                            Nearest City</th>
                        <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                            {{element.nearestCity}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="dataSourceConfig.columns"></tr>
                    <tr mat-row *matRowDef="let row; columns: dataSourceConfig.columns"></tr>

                </table>
            </div>
            </mat-tab>
            <mat-tab label="Events Map">
                <ng-template matTabContent>
                    <div class="table-container">
                        <div class="map-container">
                        <agm-map
                            [latitude]="mapCenter.lat"
                            (mapReady)="onMapReady($event)"
                            [longitude]="mapCenter.lng" [zoom]="5" style="height: 400px  !important; width: auto !important;">
                         <!--Destination maker-->
                        <agm-marker [latitude]="lat" [longitude]="lng" [title]="detail?.destination" [draggable]="false"
                            [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime)"
                            [iconUrl]="{ url:getIcon('Delivery',detail?.updateBy), scaledSize: {width: 45,height: 60}}"
                            >
                            <agm-info-window>
                                <strong>Destination: {{detail?.destination}}</strong>
                            </agm-info-window>
                        </agm-marker>
                        <!--Vehicle maker-->
                        <agm-marker *ngIf="(vehicleDet?.positionDateTime !== undefined || vehicleDet?.positionDateTime !== null)" [latitude]="vehicleDet?.latitude" [longitude]="vehicleDet?.longitude" matTooltip="text"
                            [title]=" isCustomer ? 'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') : 'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime)"
                            [draggable]="false"
                            [iconUrl]="detail?.updateTypeName === 'Driver Rest Start' ? {url:'./assets/images/Driver-rest-icon.png', scaledSize: {width: 45,height: 55} } : {url: getTruckIcon((detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd), detail?.estimatedDateTime, (detail?.type === 'Collection' ? detail?.actualCollectionDate : detail?.actualDeliveryDate)), scaledSize: {width: 45,height: 55} }">
                            <agm-info-window>
                                <strong>Reg Nr: {{vehicleDet?.vehicleLicensePlate}}</strong><br>
                                <strong>Position Date: {{vehicleDet?.positionDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                                <strong>Next location: {{detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination}}</strong><br>
                                <strong>ETA: {{detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                                <strong *ngIf="!isCustomer">Delta: {{ getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime) }}</strong>
                            </agm-info-window>
                        </agm-marker>
                        <!--Collection maker-->
                        <agm-marker [latitude]="collectionLat" [longitude]="collectionLng" [draggable]="false"
                            [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd, detail?.estimatedDateTime)"
                            [iconUrl]="{url:getIcon('Collection',detail?.updateBy), scaledSize: {width: 45,height: 60}}"
                            >
                            <agm-info-window>
                                <strong>Collection: {{detail?.collectionAddress}}</strong>
                            </agm-info-window>
                        </agm-marker>
                        <agm-marker
                            *ngFor="let event of vehicleEventMarkers"
                            [latitude]="event.latitude"
                            [longitude]="event.longitude"
                            [title]="getVehicleEventTitle(event)"
                            [iconUrl]="{ url: 'assets/images/amco-green-truck.png', scaledSize: { width: 35, height: 45 } }">
                            <agm-info-window>
                                <div>
                                    <strong>Reg:</strong> {{ event.vehicleLicensePlate }}<br>
                                    <strong>Date:</strong> {{ event.positionDateTime | date: 'dd-MMM-yyyy HH:mm' }}<br>
                                </div>
                            </agm-info-window>
                        </agm-marker>
                        <agm-polyline
                            *ngIf="vehicleEventPolylinePoints.length > 1"
                            [strokeColor]="'#15457e'"
                            [strokeWeight]="2"
                            [editable]="false"
                            [visible]="true">
                            <agm-polyline-point
                                *ngFor="let point of vehicleEventPolylinePoints"
                                [latitude]="point.lat"
                                [longitude]="point.lng">
                            </agm-polyline-point>
                        </agm-polyline>
                            <!-- Route Line
                            <agm-polyline [strokeColor]="'#15457e'" [strokeWeight]="2" [editable]="false" [visible]="true" >
                                <agm-polyline-point *ngFor="let s of redPolylinePoints; let i=index;" [latitude]="s.lat"
                                    [longitude]="s.lng">

                                </agm-polyline-point>
                            </agm-polyline> -->
                        </agm-map>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            <ng-container *ngIf="!hasUserCustomerRole || (hasAdminRole || hasManagerRole)">
                <mat-tab label="Shipment History Admin">
                    <table mat-table [dataSource]="adminAudits" class="mat-elevation-z8" style="width: 100% !important; height: 60% !important;">

                    <!-- Update Type Column -->
                    <ng-container matColumnDef="updateType">
                        <th mat-header-cell *matHeaderCellDef>Update Type</th>
                        <td mat-cell *matCellDef="let audit; let i = index">
                        <ng-container>
                            {{ getVehicleUpdateType(audit.updateType, audit.note) ? 'Vehicle Assigned' :  audit.updateType }}
                        </ng-container>
                        </td>
                    </ng-container>

                    <!-- Date/Time Column -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Date / Time</th>
                        <td mat-cell *matCellDef="let audit; let i = index">
                        {{ audit.date | date: 'dd-MMM-yyyy HH:mm' }}
                        </td>
                    </ng-container>

                    <!-- Updated At Column -->
                    <ng-container matColumnDef="updatedAt">
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Updated At</th>
                        <td mat-cell *matCellDef="let audit; let i = index">
                        {{ audit.updatedAt | date: 'dd-MMM-yyyy HH:mm' }}
                        </td>
                    </ng-container>

                    <!-- User Column -->
                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">User</th>
                        <td mat-cell *matCellDef="let audit; let i = index">
                        {{ getAuditHistoryUserDisplay(audit.user) }}
                        </td>
                    </ng-container>

                    <!-- Note Column -->
                    <ng-container matColumnDef="note">
                        <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Note</th>
                        <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis !important;">
                            <div
                                style="white-space: pre-wrap; word-break: break-word;">
                                {{ audit.note }}
                            </div>
                        </td>
                    </ng-container>

                    <!-- Disabled Column -->
                    <ng-container matColumnDef="disabled">
                        <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Disabled</th>
                        <td mat-cell *matCellDef="let audit; let i = index" colspan="2">
                            {{ audit.disabled === null ? '' : (audit.disabled === false ? 'No' : 'Yes') }}
                        </td>
                    </ng-container>

                    <!-- Approved Column -->
                    <ng-container matColumnDef="approved">
                        <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Approved</th>
                        <td mat-cell *matCellDef="let audit; let i = index" colspan="2">
                            {{ audit.approved === null ? '' : (audit.approved === false ? 'No' : 'Yes') }}
                        </td>
                    </ng-container>

                    <!-- Rejection comments  Column -->
                    <ng-container matColumnDef="rejectionComments">
                        <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Rejection Comments</th>
                        <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis;">
                        {{ audit.rejectionComments }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Actions</th>
                        <td mat-cell *matCellDef="let audit; let i = index" style=" padding: 5px;">

                                <mat-list-item [ngClass]="routeAnimationsElements">
                                    <button class="action-button"
                                        style="  font-size: 12px;
                                        font-weight: 400; margin-right: 5px; scale: 0.9; background: #f5f6fa;  color: grey;  border-radius: 0px;  text-shadow: none;  box-shadow: none; padding-bottom: 0px !important;"
                                        fxFlex="50" [matMenuTriggerFor]="actionMenu" type="button" mat-raised-button>
                                        Actions
                                    </button>
                                    <mat-menu #actionMenu="matMenu">
                                        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 5px;">
                                            <button mat-button style="margin-top: 5px; margin-left: 5px;" class="action-button"  *ngIf="hasManagerRole && audit.approved === null && audit.requiresValidation === true" (click)="approveAudit(audit)">Approve</button>
                                            <button mat-button style="margin-left: 5px; margin-top: 5px;"  *ngIf="hasManagerRole && audit.approved === null && audit.requiresValidation === true" class="action-button" (click)="rejectAudit(audit)">Reject</button>
                                            <button mat-button style="margin-left: 5px; margin-top: 5px;" class="action-button" *ngIf="audit.updateType !== 'Log an Issue'" (click)="editAudit(audit)">Edit</button>
                                            <button mat-button style="margin-bottom: 5px;margin-left: 5px; margin-top: 5px;" class="action-button"  *ngIf="audit.disabled !== true" (click)="disableAudit(audit)">Disable</button>
                                        </div>
                                    </mat-menu>
                                </mat-list-item>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsAdmin"></tr>
                    <tr mat-row *matRowDef="let audit; let i = index; columns: displayedColumnsAdmin;"
                    [ngClass]="{'light-orange': audit.requiresValidation}"></tr>
                    </table>
                </mat-tab>
            </ng-container>
            <ng-container *ngIf="!isCustomer">
                <mat-tab label="Issues">
                    <table mat-table [dataSource]="loggedAudits" class="mat-elevation-z8" style="width: 100% !important; height: 60% !important;">

                        <!-- Update Type Column -->
                        <ng-container matColumnDef="updateType">
                            <th mat-header-cell *matHeaderCellDef>Update Type</th>
                            <td mat-cell *matCellDef="let audit; let i = index">
                            <ng-container>
                                Log an Issue
                            </ng-container>
                            </td>
                        </ng-container>

                        <!-- Date/Time Column -->
                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Date / Time</th>
                            <td mat-cell *matCellDef="let audit; let i = index">
                            {{ audit.estimatedDatetime | date: 'dd-MMM-yyyy HH:mm' }}
                            </td>
                        </ng-container>

                        <!-- Updated At Column -->
                        <ng-container matColumnDef="isLoggedByCustomer">
                            <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Logged by Customer</th>
                            <td mat-cell *matCellDef="let audit; let i = index">
                            {{ audit.isLoggedByCustomer ? 'Yes' : 'No' }}
                            </td>
                        </ng-container>

                        <!-- User Column -->
                        <ng-container matColumnDef="user">
                            <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">User</th>
                            <td mat-cell *matCellDef="let audit; let i = index">
                            {{ audit.createdBy }}
                            </td>
                        </ng-container>

                        <!-- Cause of issue Column -->
                        <ng-container matColumnDef="causeOfIssue">
                            <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Cause of issue</th>
                            <td mat-cell *matCellDef="let audit; let i = index" colspan="2">
                                {{ audit.causeOfIssue  }}
                            </td>
                        </ng-container>

                        <!-- impact Column -->
                        <ng-container matColumnDef="impact">
                            <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Impact</th>
                            <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis;">
                            {{ audit.impact }}
                            </td>
                        </ng-container>

                          <!-- impact Column -->
                        <ng-container matColumnDef="reasonForIssue">
                            <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Reason for issue</th>
                            <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis;">
                            {{ audit.reasonForIssue }}
                            </td>
                        </ng-container>

                         <!-- Status Column -->
                         <ng-container matColumnDef="priority">
                            <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Priority</th>
                            <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis;">
                            {{ audit.priority | titlecase }}
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="issueStatus">
                            <th mat-header-cell *matHeaderCellDef colspan="2" style="padding-left: 10px;">Status</th>
                            <td mat-cell *matCellDef="let audit; let i = index" colspan="2"  style="text-align: left; white-space: normal; overflow: hidden; text-overflow: ellipsis;">
                            {{ audit.status === true ? 'Open' : 'Closed' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef style="padding-left: 10px;">Actions</th>
                            <td mat-cell *matCellDef="let audit; let i = index" style="display: grid; padding: 5px;">

                                    <mat-list-item [ngClass]="routeAnimationsElements">
                                        <button class="action-button"
                                            style="  font-size: 12px;
                                            font-weight: 400; margin-right: 5px; scale: 0.9; background: #f5f6fa;  color: grey;  border-radius: 0px;  text-shadow: none;  box-shadow: none; padding-bottom: 10px !important;"
                                            fxFlex="50" [matMenuTriggerFor]="actionMenu" type="button" mat-raised-button>
                                            Actions
                                        </button>
                                        <mat-menu #actionMenu="matMenu">
                                            <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 5px;">
                                                <button mat-button style="margin-left: 5px; margin-top: 5px;" class="action-button" (click)="editAudit(audit)">Edit</button>
                                            </div>
                                            <div *ngIf="audit.status" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 5px;">
                                                <button mat-button style="margin-left: 5px; margin-top: 5px;" class="action-button" (click)="onCloseClick(audit)">Close</button>
                                            </div>
                                        </mat-menu>
                                    </mat-list-item>

                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="loggedIssuesColumns"></tr>
                        <tr mat-row *matRowDef="let audit; let i = index; columns: loggedIssuesColumns;"></tr>
                        </table>
                </mat-tab>
            </ng-container>
        </mat-tab-group>
    </mat-dialog-content>


</mat-card>
